import axios from 'axios';
import CryptoJS from 'crypto-js';
const BASE_URL = 'https://serco.eprime.app/api/crud';

// const BASE_URL = 'http://localhost:3500/api/crud';

 // Replace with your actual base URL
const AUTH_TOKEN = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsInJvbGUiOiJhZG1pbiJ9.wNzeQVdIoGM/AdRxOmkMV+vOVzmh6kkRUvbpYV1rtzg='; // Replace w
const ENCRYPTION_KEY='b14ca5898a4e4133bbce2ea2315a1916';
const IV='e5b8d7a3c6f9g8h1';


const encrypt = (data) => {
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY), {
    iv: CryptoJS.enc.Utf8.parse(IV),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();

  return ciphertext;
};

const decrypt = (ciphertext) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY), {
    iv: CryptoJS.enc.Utf8.parse(IV),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};


const apiMiddleware = async (method = 'POST', body = {}, headers = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json',
    Authorization: AUTH_TOKEN, // Replace with your JWT token retrieval logic
    ...headers,
  };

  const encripted = encrypt(body);


  try {
    const response = await axios({
      method,
      url: `${BASE_URL}`,
      headers: defaultHeaders,
      data: JSON.stringify({ENCDATA:encripted}),
    });



    const Result = decrypt(response.data)
    
    
    return {
      success: true,
      data: Result,
    };


    


  } catch (error) {
    console.error('API Error:', error);
    return {
      success: false,
      error: error.response?.data || 'An unexpected error occurred',
    };
  }
};

export default apiMiddleware;
